import { Link } from 'react-router-dom';
import { useBreadcrumbContext } from '../../contexts/BreadcrumbContext';
import ChevronIcon from '../icons/ChevronIcon';
import Header from './Header';
import HeaderToggleButtons from './HeaderToggleButtons';

export interface BreadcrumbHeaderProps {
  rootText?: string; // Optional text to display as the first breadcrumb
  rootUrl?: string; // Optional url for the root text. Will also replace :rootUrl in breadcrumb urls.
  showToggleButtons?: boolean;
}

// Breadcrumbs are managed using setBreadcrumbs and clearBreadcrumbs from BreadcrumbContext.
const BreadcrumbHeader = ({
  rootText,
  rootUrl,
  showToggleButtons = false,
}: BreadcrumbHeaderProps) => {
  const { breadcrumbs } = useBreadcrumbContext();
  const rootLink =
    rootUrl != null && breadcrumbs.length > 0 ? (
      <Link key={rootUrl} to={rootUrl} className="font-weight-normal">
        {rootText}
      </Link>
    ) : (
      rootText
    );

  return (
    <Header>
      <h3 className="d-flex align-items-center">
        {rootLink}
        {breadcrumbs.map(({ display, url }, i) => (
          <div key={display} className="d-flex align-items-center">
            {/* Only show the first chevron if rootText is present */}
            {(rootText || i > 0) && (
              <ChevronIcon direction="right" className="mx-2" />
            )}
            {url == null ? (
              display
            ) : (
              <Link
                to={rootUrl ? url.replace(':rootUrl', rootUrl) : url}
                className="font-weight-normal"
              >
                {display}
              </Link>
            )}
          </div>
        ))}
      </h3>

      {showToggleButtons && <HeaderToggleButtons />}
    </Header>
  );
};

export default BreadcrumbHeader;
